import { useCallback, useReducer } from "react";
import { LensSourcesDomainModel, LensSourcesDomainModelFunctions } from "../domain/LensSourcesDomainModel";

export function useLensSourcesDomain() {
    const [lensSources, dispatch] = useReducer(lensSourcesDomainModelReducer, new LensSourcesDomainModel());

    const replace = useCallback((newState: LensSourcesDomainModel) => {
        dispatch({ type: "replace", newState });
    }, []);

    const filter = useCallback(
        (newValue: string) =>
            dispatch({
                type: "filter",
                newValue,
            }),
        [],
    );

    return {
        replace,
        lensSources,
        filter,
    };
}

type LensSourcesDomainModelActions =
    | {
          type: "replace";
          newState: LensSourcesDomainModel;
      }
    | { type: "filter"; newValue: string };

function lensSourcesDomainModelReducer(previousState: LensSourcesDomainModel, action: LensSourcesDomainModelActions) {
    switch (action.type) {
        case "replace":
            return action.newState;
        case "filter":
            return LensSourcesDomainModelFunctions.filter(previousState, action.newValue);
        default:
            return previousState;
    }
}
